import React from "react";
import {Button, List} from "antd";
import {ExecutableModalProps} from "../../../../models/Modals";
import {DepartmentDataService} from "../../../../models/DepartmentData/DepartmentDataService";
import ExecutableModal from "../../../executableModal/ExecutableModal";
import {DEPARTMENT_DATA_SERVICES} from "../../../../constants/translates";

type ViewDepartmentDataServicesModalProps = ExecutableModalProps<{
  services: DepartmentDataService[];
}>;

const ViewDepartmentDataServicesModal = ({
  handler,
  services,
}: ViewDepartmentDataServicesModalProps) => (
  <ExecutableModal
    handler={handler}
    title={DEPARTMENT_DATA_SERVICES.viewTitle}
    width={370}
    footer={[
      <Button key="close" onClick={handler.executeClose}>
        {DEPARTMENT_DATA_SERVICES.close}
      </Button>,
    ]}
  >
    <List
      dataSource={services}
      renderItem={(service) => (
        <List.Item key={service.service_id}>
          <span>{service.name}</span>
          <span>{service.amount} {DEPARTMENT_DATA_SERVICES.currency}</span>
        </List.Item>
      )}
    />
  </ExecutableModal>
);

export default ViewDepartmentDataServicesModal;
